
import RouteComponent from './setup/route.component';
import './App.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "aos/dist/aos.css";
import AOS from "aos";

import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import NoInternetConnection from './components/NoInternetConnection';
import { useLocation } from 'react-router-dom';
import { setPreviousRouteAction } from './store/actions/theme';
import { useDispatch } from 'react-redux';
export default function App() {
    const location = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
      // This function will be called whenever the route changes
      console.log('Route changed to ', location.pathname);
  
      dispatch(setPreviousRouteAction(location.pathname))
    }, [location.pathname])
    useEffect(() => {
        AOS.init();
    }, [])

    return (
        <>
            <NoInternetConnection>
                <ToastContainer theme="dark" autoClose={1000} />
                <RouteComponent />
            </NoInternetConnection>
        </>
    );

}

